<template>
  <div class="each-report-wrap">
    <div class="dynamic-fields">
      <div class="message-avatar-reported-wrap">
        <div class="message-reported-wrap">
          <div class="message-avatar">
            <!-- <img
              class="frame"
              :src="
                imageBaseUrl +
                'api/users/' +
                'pictureframe?rol_id=' +
                rol_id +
                '&type=circle' +
                '&sid=' +
                sid
              "
              draggable="false"
            /> -->
            <img :src="image" alt="user-avatar.jpg" />
            <div class="message">{{ report.msg }}</div>
          </div>
          <div class="reported-time">
            <div>{{ report.reported_user }}</div>
            <div>{{ msgTime }}</div>
          </div>
        </div>
      </div>
      <div class="info">
        <span>{{
          $t("reports.reportedUser") + ": " + report.reported_user
        }}</span>
        <span>{{ $t("reports.reportedBy") + ": " + report.reported_by }}</span>
        <span
          >{{ $t("reports.reason") + ": "
          }}<strong>{{ report.reason }}</strong></span
        >
        <span
          >{{ $t("reports.numberOfReports") + ": "
          }}<strong>{{ report.num_reported }}</strong></span
        >
      </div>
    </div>
    <div class="buttons-wrap">
      <div class="buttons-line">
        <button class="ban-button" @click="emitActionAndReportId('ban')">
          <div>{{ $t("button.banUser") }}</div>
          <div class="icon">
            <span class="material-icons">block</span>
          </div>
        </button>
        <button class="delete-button" @click="emitActionAndReportId('delete')">
          <div>{{ $t("button.deleteMessage") }}</div>
          <div class="icon">
            <span class="material-icons">delete</span>
          </div>
        </button>
        <button class="ignore-button" @click="emitActionAndReportId('ignore')">
          <div>{{ $t("button.ignore") }}</div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      image: "",
      imageBaseUrl: process.env.VUE_APP_VIDEO_BASE,
    };
  },
  props: {
    report: Object,
  },
  computed: {
    sid() {
      return localStorage.getItem("sid");
    },
    rol_id() {
      return localStorage.getItem("rol_id");
    },
    msgTime() {
      let serverDateTime = moment.utc(
        this.report.msg_time,
        "YYYY-MM-DD HH:mm:ss"
      );
      let localTime = serverDateTime.local().format("HH:mm");
      return localTime;
    },
  },
  mounted() {
    this.getUserAvatar();
  },
  methods: {
    async getUserAvatar() {
      try {
        this.startLoading();
        this.image = await this.getImageUsrId(this.report.usr_id);
      } catch (error) {
        this.handleError(error);
      }
      this.stopLoading();
    },
    emitActionAndReportId(action) {
      this.$emit("set-report-id", this.report.rpt_id);
      this.$emit(action);
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.each-report-wrap {
  display: flex;
  flex-direction: row;
  min-height: 125px;
  margin-bottom: 2%;
}
.dynamic-fields {
  display: flex;
  flex-direction: row;
  width: 60%;
}
.buttons {
  width: 40%;
}
.message-avatar-reported-wrap {
  display: flex;
  align-items: center;
  padding-left: 60px;
  width: 50%;
}
.message-avatar-reported-wrap img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  position: absolute;
  bottom: 0px;
  left: -60px;
}
.message-avatar {
  position: relative;
  display: flex;
  flex-direction: column-reverse;
}
.frame {
  position: absolute;
}
.message {
  display: inline-block;
  background-color: white;
  padding: 10px;
  border-radius: 20px 20px 20px 0;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.08);
  word-break: break-word;
}
.reported-time {
  font-size: 13px;
  display: flex;
  height: 20%;
  justify-content: space-between;
}
.reported-time div:nth-of-type(1) {
  margin-right: 10px;
}

.info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px;
  width: 50%;
}
.info span {
  margin: 0.5% 0;
}

.buttons-wrap {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 40%;
}
.buttons-line {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}
.buttons-line button {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  border: none;
  padding: 2% 4%;
  font-size: 1em;
  border-radius: 100px;
  font-size: 13px;
}
.buttons-line button:focus {
  border: none;
  outline: none;
}
.buttons-line .icon {
  display: flex;
  align-items: center;
  padding-left: 15px;
}
.icon span {
  font-size: 18px;
}
.ban-button {
  background: var(--button-color-blue);
  color: white;
}
.delete-button {
  background: var(--button-color-bright-red);
  color: white;
}
.ignore-button {
  background: white;
  color: black;
}
</style>